module.exports = __webpack_public_path__ + "img/sulv_2.f7d4cf9c.jpg";